@let assignmentOptimizerKpi =
  shiftTimelineDraftHelperService.assignmentOptimizerKpi$ | async;
@let isLoadingAssignmentOptimizerKpi =
  !!(shiftTimelineDraftHelperService.isLoadingAssignmentOptimizerKpi$ | async);
<wilson-timeline-page-frame>
  <div class="d-flex justify-content-between align-items-center" headerContent>
    <div class="gap-2 d-flex justify-content-start align-items-center">
      <wilson-shift-timeline-draft-header></wilson-shift-timeline-draft-header>
    </div>

    <div class="header-filter-box d-flex px-0">
      @if (assignmentOptimizerKpi?.free_text_field) {
        <div class="d-flex align-items-center me-2">
          <ng-template #headerContent>
            <div [innerHTML]="assignmentOptimizerKpi?.free_text_field"></div>
          </ng-template>
          <fa-icon
            nz-tooltip
            [nzTooltipTitle]="headerContent"
            [icon]="faExclamationCircle"
            class="icon-style"
          ></fa-icon>
        </div>
      }
      <div class="d-flex align-items-center h-100">
        @if (assignmentOptimizerKpi?.total_kpis?.length) {
          <div class="divider"></div>
          <div
            class="collapse-button d-flex justify-content-center align-items-center cursor-pointer"
            (click)="
              assignmentOptimizerKpi?.total_kpis?.length && toggleKPICard()
            "
            [ngClass]="
              isKPICardOpen ? 'collapse-icon-right' : 'collapse-icon-left'
            "
          >
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </div>
          <div class="divider"></div>
        }
        <wilson-timeline-draft-header-kpi-section
          class="ps-2"
          [isKPICardOpen]="isKPICardOpen"
          [globalAssignmentKpis]="assignmentOptimizerKpi?.total_kpis"
          [isLoadingUserAssignmentKpi]="isLoadingAssignmentOptimizerKpi"
        ></wilson-timeline-draft-header-kpi-section>
      </div>
    </div>
  </div>

  <wilson-assignments-gantt-chart
    mainContent
    [isCellView]="(isCellView$ | async) || false"
    [highlightedShiftIds]="highlightedShiftIds$ | async"
    [userTemplate]="userInfoTemplate"
    [searchTemplate]="searchTemplate"
    [frameLength]="(frameWidth$ | async) || 0"
    [ganttChartUsers]="shiftTimelineDraftHelperService.assignments$ | async"
    [unassignedShifts]="
      shiftTimelineDraftHelperService.unassignedShifts$ | async
    "
    [publicHolidaysRegion]="publicHolidaysRegion$ | async"
    [timeframe]="timeframe$ | async"
    [determinedShiftActivities]="determinedShiftActivities$ | async"
    [pixelWidthPerDay]="(pixelWidthPerDay$ | async) || 0"
    [widthBreakpointPx]="widthBreakpointPx"
    [isDragAndDropEnabled]="true"
    (ready)="onGanttChartReady($event)"
    (assignShift)="assignShiftAndUpdateUsersKpis($event)"
    (reassignShift)="reassignShiftAndUpdateUsersKpis($event)"
    (unassignShift)="unassignShiftAndUpdateUsersKpis($event)"
  ></wilson-assignments-gantt-chart>
</wilson-timeline-page-frame>

<ng-template #userInfoTemplate let-user="user">
  <wilson-user-timelines-draft-info-card
    [user]="user"
    [userAssignmentKpis]="assignmentOptimizerKpi?.user_kpis?.[user.id]"
    [isLoadingUserAssignmentKpi]="isLoadingAssignmentOptimizerKpi"
  ></wilson-user-timelines-draft-info-card>
</ng-template>

<ng-template #searchTemplate>
  <div class="header d-flex align-items-center px-2">
    <wilson-search-filter
      class="w-100 me-2"
      (modelChange)="shiftTimelineDraftHelperService.setSearchTerm($event)"
    ></wilson-search-filter>
  </div>
</ng-template>
<wilson-deferred-assignment-shift-card></wilson-deferred-assignment-shift-card>
<wilson-deferred-absence-timeline-view-card></wilson-deferred-absence-timeline-view-card>
<wilson-deferred-absence-cell-view-card></wilson-deferred-absence-cell-view-card>
<wilson-deferred-stay-card></wilson-deferred-stay-card>
<wilson-deferred-cluster-card></wilson-deferred-cluster-card>
<wilson-deferred-assignment-shift-card-cell-view></wilson-deferred-assignment-shift-card-cell-view>
<wilson-deferred-unassigned-shift-card-cell-view></wilson-deferred-unassigned-shift-card-cell-view>
<wilson-deferred-shift-icons></wilson-deferred-shift-icons>
